<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <Left @nodeClicked='nodeClicked'></Left>
    </template>
    <template v-slot:right_view>
      <Right v-bind:nodeParam='nodeParam' ref="rightKpiChart"></Right>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import Left from '../../components/pmConfig/KpiChart/left/left';
import Right from '../../components/pmConfig/KpiChart/right/right';

export default {
  name: 'KpiChartShowPage',
  components: {
    BasicLayout,
    Left,
    Right,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Pm.kpiChartShow')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        name: '',
        crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.cycleMeasurement')}/${this.$t('Pm.kpiChartShow')}`
      },
      nodeParam: {}
    };
  },
  methods: {
    nodeClicked(payload) {
      this.nodeParam = payload;
      // console.log('first',payload,this.nodeParam);
    }
  }
};
</script>

<style scoped>

</style>
